import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import OutboundCallNew from './icon-outbound-call-new.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <OutboundCallNew {...validProps} />;
}
SvgComponent.iconName = 'outboundCallNew';

export const OutboundCallIconNew = svgIconWrapper(SvgComponent);
